function Bauble(x, y, r, img) {
  this.body = Bodies.circle(x, y, r*0.75, { restitution: 0.01, friction: 0.2 });
  this.r = r
  this.img = img;
  Composite.add(world, this.body);

  this.show = function () {
    const pos = this.body.position;
    const angle = this.body.angle;

    push();
    translate(pos.x, pos.y);
    rotate(angle);
    imageMode(CENTER);
    image(this.img, 0, 0, this.r*2, this.r*2);
    pop();
  }
}